import { render, staticRenderFns } from "./ViewPlagueMonitoring.vue?vue&type=template&id=ee95c490&scoped=true&lang=html&"
import script from "./ViewPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./ViewPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee95c490",
  null
  
)

export default component.exports